export default __webpack_public_path__ + "coupon-icon.6aca438617a4dd4ddc20207bd653ba1a.svg";